import(/* webpackMode: "eager" */ "/opt/calcom/apps/web/app/error.tsx");
